module.exports = __webpack_public_path__ + "static/media/police-box.4c3e0818.svg";